export default __webpack_public_path__ + "static/gift-green-49e4c5de2e3c8e55722ea80fef527149.png";